export default __webpack_public_path__ + "static/media/character-icon.2da2dfee.svg";